'use client';
import { useState } from 'react';
import Slider from 'react-slick';
import parser from 'html-react-parser';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

import { parseOptions } from '@/utils/parseOptions';
import { getTranslation } from '@/lib/utils';
import MediaFilterImage from '@/components/Media/MediaFilterImage';
import { Locale } from '../../../i18n.config';

const settings = {
  dots: false,
  infinite: true,
  speed: 1500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
};

type Props = {
  GuideItems: GuideItem[];
  lang: Locale;
};

type GuideItemCarouselCardProps = {
  GuideItem: GuideItem;
  lang: Locale;
};

export function MapCarousel({ GuideItems, lang }: Props) {
  const [sliderRef, setSliderRef] = useState<Slider | null>(null);

  const singleGuideItem = GuideItems.length === 1;

  return (
    <>
      {singleGuideItem ? (
        <GuideItemCarouselCard lang={lang} GuideItem={GuideItems[0]} />
      ) : (
        <div className="relative block max-w-[400px] w-[400px] max-h-[110px] overflow-hidden pr-[30px] pl-[50px] box-border">
          <button
            onClick={sliderRef?.slickPrev}
            className="absolute top-[50%] cursor-pointer left-[15px] translate-y-[-50%] outline-none">
            <FiChevronLeft className="w-10 h-10" />
          </button>
          <Slider ref={setSliderRef} {...settings}>
            {GuideItems.map((GuideItem, i) => (
              <GuideItemCarouselCard
                lang={lang}
                GuideItem={GuideItem}
                key={i}
              />
            ))}
          </Slider>
          <button
            onClick={sliderRef?.slickNext}
            className="absolute top-[50%] cursor-pointer right-0 translate-y-[-50%] outline-none">
            <FiChevronRight className="w-10 h-10" />
          </button>
        </div>
      )}
    </>
  );
}

function GuideItemCarouselCard({
  GuideItem,
  lang,
}: GuideItemCarouselCardProps) {
  // const GuideItemImgCover = GuideItem.media.filter(
  //   (medias) => medias.type == 'cover',
  // )[0];

  return (
    <div className="flex w-[320px] h-full min-h-[1px] float-left">
      <div className="flex max-w-[350px] space-x-4">
        <div className="relative h-24 aspect-square">
          <MediaFilterImage
            media={GuideItem.surrounding?.image}
            filterName="small_1-1"
            loading="lazy"
            className="w-full h-full block align-middle"
            alt={
              getTranslation(GuideItem.surrounding?.translate || [], lang).title
            }
            fill={true}
          />
        </div>
        <div className="flex flex-col gap-y-2 font-text max-h-full overflow-hidden text-base font-light">
          <h6>
            {getTranslation(GuideItem.surrounding?.translate || [], lang).title}
          </h6>
          <div className="text-sm text-gray-600 text-ellipsis overflow-hidden line-clamp-3">
            {
              parser(
                getTranslation(GuideItem.surrounding?.translate || [], lang).description || '', 
                parseOptions
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
}
